import { styles as commonStyles } from '../../base/styles/common.scss';
import { styles as styleHelpersStyles } from '../../../../assets/style-helpers.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';

export const templateAzureCWSensor = document.createElement('template');

templateAzureCWSensor.innerHTML = `
  <style>${styleHelpersStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${commonStyles}</style>
  
  <div class="form-wrapper" id="integration-types">
    <gz-form-field  class="sensor-select-wrapper mb-2">
       <gz-checkbox gz-form-input class="sensor-select" style="display: none" checked></gz-checkbox>
    </gz-form-field>
    <div class="sensor-data">
      <div class="sensor-data-list">        
        <gz-form-field label="" id="azure_cw_application_id" stacked required>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        
        <gz-form-field label="" id="azure_cw_tenant_id" stacked required>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>

        <gz-form-field label="" id="azure_cw_client_secret" stacked required>
          <gz-input gz-form-input="" type="password" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
        
        <gz-form-field label="" id="azure_cw_subscription_id" stacked required>
          <gz-input gz-form-input="" type="text" ></gz-input>
          <gz-input-error></gz-input-error>
        </gz-form-field>
      </div>
    </div>
  </div>
`;
